import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import Yup from '../../utils/yup';
import { useLoader } from '../../provider/LoaderProvider';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import { Form, Formik } from 'formik';
import { FormButtonPanelUI } from '../Interface';
import ProdNonProductiveWorkFields from './ProdNonProductiveWorkFields';
import prodNonProductiveWorkService from '../../service/prodNonProductiveWork.service';

const ProdNonProductiveWorkPage = ({ dialog }) => {
  const { showLoader, hideLoader } = useLoader();
  const [initValues, setInitValues] = useState({});

  const def = {
    description: '',
    date: dayjs(),
    timeSpentInMin: '',
  };

  useEffect(() => {
    setInitValues(def);
  }, []);

  const validationSchema = Yup.object().shape({
    description: Yup.string().required(),
    date: Yup.string().required(),
    timeSpentInMin: Yup.number().positive().required(),
  });

  const handleInsertObject = (values, { resetForm }) => {
    showLoader();

    const insertObject = {
      ...values,
      createdBy: dialog?.data?.createdBy ?? null,
      date: dayjs(values.date).startOf('day').add(12, 'hour').toISOString(),
    };

    prodNonProductiveWorkService
      .createData(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        resetForm();

        if (dialog) {
          dialog.handleClose();
        }
      })
      .finally(() => {
        hideLoader();
      });
  };

  return (
    <Formik
      initialValues={initValues}
      validationSchema={validationSchema}
      validateOnChange={false}
      onSubmit={handleInsertObject}
      enableReinitialize
    >
      {({ resetForm }) => (
        <Form>
          <ProdNonProductiveWorkFields />
          <FormButtonPanelUI
            onCancelClick={() => {
              resetForm();
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ProdNonProductiveWorkPage;
